export const config = {
  title: "JLW Creative Ventures LLC | Real Estate Strategy in Buffalo, MN",
  meta: {
    description:
      "JLW Creative Ventures LLC provides strategic real estate investment and consulting in Buffalo, MN. We specialize in data-driven insights, property lifecycle strategies, market analysis, and long-term portfolio growth.",
    keywords: [
      "JLW Creative Ventures LLC",
      "real estate consulting Buffalo MN",
      "real estate investment strategy",
      "property portfolio growth",
      "market research real estate",
      "risk management real estate"
    ],
    author: "JLW Creative Ventures LLC",
    canonicalUrl: "https://jlwcreativeventuresllc.com/",
  },
  sections: {
    header: {
      businessName: "JLW Creative Ventures LLC",
    },
    sectionB: {
      heroTitle: "Smarter Investing, Strategic Growth",
      heroSubtitle: "Expert Real Estate Consulting & Investment Strategies",
      learnAboutText: "Discover Our Approach",
      phoneNumber: "7635929603",
      phoneLabel: "(763) 592-9603",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1384411573/photo/asia-stock-trader-agent-or-sale-tax-loan-broker-advice-brief-and-point-hand-to-graph-report.jpg?s=612x612&w=0&k=20&c=WimpF5FYzcha02s4FxZIOKcomnT0G0YQQ0G0GTB7PFE=",
      cardData: [
        {
          title: "Real Estate Strategy",
          description:
            "Tailored property lifecycle strategies built on data-driven insights.",
        },
        {
          title: "Market Research",
          description:
            "Comprehensive analysis to identify opportunities and mitigate risks.",
        },
        {
          title: "Portfolio Growth",
          description:
            "Long-term planning and execution to maximize returns sustainably.",
        },
      ],
      description:
        "JLW Creative Ventures LLC helps investors and businesses achieve financial goals with precision real estate strategies. We provide clarity, performance, and sustainable growth through innovative, data-driven planning.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive real estate consulting solutions designed to guide clients through every phase of the property lifecycle.",
      cards: [
        {
          title: "Property Lifecycle Strategies",
          description:
            "Customized plans for acquisition, repositioning, and market entry.",
          imageSrc: "https://media.istockphoto.com/id/1487839236/photo/couple-meeting-with-financial-advisor.jpg?s=612x612&w=0&k=20&c=P3Mo-b3Njnc6l9c8rR6vZkdUbkyoLnruP6EQ9BjLAi4=",
          imageAlt: "Property Lifecycle Strategies",
        },
        {
          title: "Risk Management & Market Analysis",
          description:
            "Identify risks and leverage market research for smarter investments.",
          imageSrc: "https://media.istockphoto.com/id/1413884806/photo/financial-advisor-or-lawyer-with-couple-explaining-options.jpg?s=612x612&w=0&k=20&c=mJJj0ppZeh2oPxPsOI6Ofx-zemy-lrBuaTYTQrwnoPc=",
          imageAlt: "Market Analysis",
        },
        {
          title: "Long-Term Portfolio Growth",
          description:
            "Strategies to balance short-term wins with sustainable long-term value.",
          imageSrc: "https://media.istockphoto.com/id/170652637/photo/couple-signing-contract.jpg?s=612x612&w=0&k=20&c=WgMWSJcUxEBziQy8nXHQPR0kW4aIFvPby8MSukk57l0=",
          imageAlt: "Portfolio Growth",
        },
      ],
      otherServicesTitle: "Why Work With Us?",
      otherServicesList: [
        "Innovative investment approaches",
        "Comprehensive market research",
        "Open & honest communication",
        "Sustainable financial strategies",
        "Proven track record in real estate consulting",
      ],
    },
    sectionD: {
      aboutTitle: "About JLW Creative Ventures LLC",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2155527498/photo/asian-businesswoman-discusses-home-purchase-contracts-with-clients-at-her-desk-focusing-on.jpg?s=612x612&w=0&k=20&c=vSLUrcEeGPlL_P0BFxzMK03Cfcuiaz4Z2R17whH4auI=",
        alt: "JLW Creative Ventures Team",
      },
      aboutText: [
        "JLW Creative Ventures LLC, led by Managing Director Anthony Wold, was founded with a mission to help clients navigate real estate opportunities with clarity and confidence.",
        "We blend short-term wins with long-term planning, using transparency, accountability, and innovation to ensure every client’s portfolio is built for performance and endurance.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "JLW Creative Ventures LLC Logo",
      businessName: "JLW Creative Ventures LLC",
      contact: {
        phone: "7635929603",
        phoneLabel: "(763) 592-9603",
        email: "anthonywold@hotmail.com",
        website: "https://jlwcreativeventuresllc.com/",
        address: "Buffalo, MN 55313",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "Buffalo, MN 55313",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2924.439159!2d-93.873!3d45.171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87f7421b1234567%3A0xabcdef123456789!2sBuffalo%2C%20MN%2055313!5e0!3m2!1sen!2sus!4v1714567890123!5m2!1sen!2sus",
    },
  },
};

export default config;
